import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { parseBrazilianNumber } from '../../../utils/formatUtils';
import { FormField, ResultCard, EducationalBlock } from '../finance/shared';

const WeightedMeanCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [values, setValues] = useState([{ value: '', weight: '' }, { value: '', weight: '' }]);
  const [result, setResult] = useState<any>(null);

  const calculate = () => {
    const valid = values.filter(e => e.value && e.weight);
    if (valid.length === 0) return;

    const entries = valid.map(e => ({
      val: parseFloat(parseBrazilianNumber(e.value)) || 0,
      w: parseFloat(parseBrazilianNumber(e.weight)) || 0
    })).filter(e => e.w > 0);

    if (entries.length === 0) return;

    const weightedSum = entries.reduce((s, e) => s + (e.val * e.w), 0);
    const totalW = entries.reduce((s, e) => s + e.w, 0);
    const mean = weightedSum / totalW;

    setResult({ mean, totalW });
    onResultChange([
      { label: 'Média Ponderada', value: mean.toFixed(2) },
      { label: 'Peso Total', value: totalW.toFixed(2) }
    ]);
  };

  const handleChange = (index: number, field: 'value' | 'weight', val: string) => {
    const next = [...values];
    next[index] = { ...next[index], [field]: val };
    setValues(next);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-6 rounded-2xl border border-theme-border">
        <h2 className="text-xl font-bold text-theme-text mb-3">Média Ponderada</h2>
        <p className="text-theme-muted mb-4">Calcule médias onde cada valor tem um peso diferente.</p>
      </div>

      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-lg font-bold">Valores e Pesos</h3>
          <button onClick={() => setValues([...values, { value: '', weight: '' }])} className="px-4 py-2 bg-accent-gradient text-white rounded-lg">Adicionar</button>
        </div>
        <div className="space-y-4">
          {values.map((e, i) => (
            <div key={i} className="flex gap-3">
              <FormField label="Valor" value={e.value} onChange={(v) => handleChange(i, 'value', v)} isNumeric type="text" />
              <FormField label="Peso" value={e.weight} onChange={(v) => handleChange(i, 'weight', v)} isNumeric type="text" />
              {values.length > 2 && (
                <button onClick={() => setValues(values.filter((_, idx) => idx !== i))} className="px-4 py-3 bg-rose-600 text-white rounded-xl self-end">X</button>
              )}
            </div>
          ))}
        </div>
        <div className="mt-8 flex justify-center">
          <button onClick={calculate} className="px-12 py-4 bg-accent-gradient text-white rounded-xl font-bold">Calcular</button>
        </div>
      </div>

      {result && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <ResultCard title="Média Ponderada" value={result.mean.toFixed(2)} color="indigo" />
          <ResultCard title="Peso Total" value={result.totalW.toFixed(2)} color="slate" />
        </div>
      )}
    </div>
  );
};

export default WeightedMeanCalculator;
